import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconLicenceSvg } from "./IconLicenceSvg.mjs";
const IconLicence = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconLicenceSvg, ...svgProps }) });
export {
  IconLicence
};
